module.exports = __webpack_public_path__ + "assets/images/Community.030f92e18561357d6354a7cbe173ce2a.svg";